import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main-implementos',
  templateUrl: './main-implementos.component.html',
  styleUrls: ['./main-implementos.component.css']
})
export class MainImplementosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
